import styled, { css } from 'styled-components'

export const StyledValue = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 38px;
    height: 20px;
    margin-right: 12px;
    padding: 2px 8px;
    font-size: 12px;
    letter-spacing: 0.4px;
    ${({ rawstate, state }) => !rawstate && state === 0 && css`
        color: ${({ theme }) => theme.whiteTwo};
        background: ${({ theme }) => theme.grassyGreen};
    `};
    ${({ rawstate, state }) => !rawstate && state > 0 && css`
        color: ${({ theme }) => theme.whiteTwo};
        background: ${({ theme }) => theme.pastelRed};
        &:before {
            content: '';
            display: inline-block;
            position: absolute;
            left: 50%;
            bottom: 100%;
            width: 0;
            height: 0;
            border-style: solid;
            border-width: 0 16px 3px 16px;
            border-color: transparent transparent ${({ theme }) => theme.pastelRed} transparent;
            margin-left: -16px;
        }
    `};
    ${({ rawstate, state }) => !rawstate && state < 0 && css`
        color: ${({ theme }) => theme.whiteTwo};
        background: ${({ theme }) => theme.pastelRed};
        &:before {
            content: '';
            display: inline-block;
            position: absolute;
            left: 0;
            top: 100%;
            width: 0;
            height: 0;
            border-style: solid;
            border-width: 3px 16px 0 16px;
            border-color: ${({ theme }) => theme.pastelRed} transparent transparent transparent;
        }
    `};
    ${({ rawstate }) => rawstate && css`
        color: ${({ theme }) => theme.black};
        background: 'transparent';
        border: ${({ theme }) => `1px solid ${theme.black}`};
    `};
`